const ACTIONS = {
  VIEW: {
    text: 'View details',
    key: 'viewDetails',
  },
  VIEW_LOGS: {
    text: 'View logs',
    key: 'viewLogs',
  },
  EDIT: {
    text: 'Edit',
    key: 'edit',
  },
  DISABLE: {
    text: 'Disable',
    key: 'disable',
  },
  DELETE: {
    text: 'Delete',
    key: 'delete',
  },
  TEST: {
    text: 'Test',
    key: 'test',
  },
  VERIFY: {
    text: 'Verify',
    key: 'verify',
  },
  ENABLE: {
    text: 'Enable',
    key: 'enable',
  },
};


const statusMap = {
  // Active aka Enabled aka Verified
  ACTIVE: {
    text: 'Enabled',
    actions: [
      ACTIONS.TEST,
      ACTIONS.VIEW,
      ACTIONS.VIEW_LOGS,
      ACTIONS.EDIT,
      ACTIONS.DISABLE,
      ACTIONS.DELETE,
    ],
  },
  UNVERIFIED: {
    text: 'Unverified',
    actions: [
      ACTIONS.VERIFY,
      ACTIONS.VIEW,
      ACTIONS.VIEW_LOGS,
      ACTIONS.EDIT,
      ACTIONS.DELETE,
    ],
  },
  INACTIVE: {
    text: 'Disabled',
    actions: [
      ACTIONS.ENABLE,
      ACTIONS.VIEW,
      ACTIONS.VIEW_LOGS,
      ACTIONS.EDIT,
      ACTIONS.DELETE,
    ],
  },
};

const getStatusText = status => statusMap[status].text;
const getActions = status => statusMap[status].actions;

export {
  getStatusText,
  getActions,
  ACTIONS,
};
